module.exports = __webpack_public_path__ + "img/rowing.75c5fcee.jpg";